import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilService } from './../../../../shared/services/util/util.service';
import { EventsService, CookieService, VariablesService } from '../../../../shared/services';
import { HomepageService } from '../../../../shared/services/homepage/homepage.service';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-exit-intent',
  templateUrl: './exit-intent.component.html',
  styleUrls: ['./exit-intent.component.scss']
})
export class ExitIntentComponent implements OnInit {
  name: FormControl;
  mobile: FormControl;
  leadForm: FormGroup;
  extn: string;
  isSuccess = false;
  formInfo = {
    'name': {
      'placeholder': 'Name',
      'error': {
        'maxlength': 'Maximum character limit exceeds',
        'pattern': 'Please enter a valid name'
      },
    },
  };
  constructor(
    private homePageService: HomepageService,
    private eventsService: EventsService,
    private utilService: UtilService,
    public dialogRef: MatDialogRef<ExitIntentComponent>,
    private cookieService: CookieService,
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.leadForm = new FormGroup({
      name: this.name = new FormControl('', [
        Validators.required,
        Validators.pattern(/[a-z.'-]{4,}/i)
      ]),
      mobile: this.mobile = new FormControl('', [
        Validators.required
      ]),
    });
    this.getextn();
  }

  getextn() {
    this.utilService.number$.subscribe(res => this.extn = res.extn);
  }

  lead() {
    const ku = this.cookieService.getCookie('_ku');
    if (this.leadForm.valid) {
      const leadPayload = {
        name: this.name.value,
        email: `${ku}@ketto.org`,
        extension: this.extn,
        phone: this.mobile.value,
        about: 'Login exit intent',
        page: 'home',
        query_type: 'want_to_raise_funds',
        type: 'ketto-campaign-lead',
        mail_to: this.variablesService.leadMailTo,
        subject: 'Exit intent desktop-' + this.variablesService.leadSubject,
        city: this.utilService.getCityFromIp()
      };
      Object.assign(leadPayload, this.utilService.getUTMs());
      this.homePageService.postLeadData(leadPayload).subscribe(
        (res: any) => {
          if (res.error === false) {
            const pageViewPayload = {
              eventName: 'campaign_lead_created',
              event_type: 'campaign',
              info_2: res.data.id,
              page_name: 'home',
              referrer_page: ''
            };
            this.eventsService.sendSystemEvent(pageViewPayload).subscribe();
            this.isSuccess = true;
          } else {
            this.isSuccess = false;
          }
        },
        (err) => {
          this.utilService.openSnackBar(err.error.message, 'error');
        }
      );
    } else {
      this.utilService.checkValidForm(this.leadForm);
    }
  }
}
